module.exports = __webpack_public_path__ + "img/cash.2c12a77a.svg";